import React from "react";
import Navbar from "../layout/Navbar";
import WaveEffect from "../Components/WaveEffect";
import image1 from "../assests/Images/INGIheroImage.png";
import { FaDownload } from "react-icons/fa";
import { CiLock } from "react-icons/ci";
import { MdOutlineSecurity } from "react-icons/md";
import { GrLicense } from "react-icons/gr";
import { FaPersonMilitaryRifle } from "react-icons/fa6";
import { FaPlane } from "react-icons/fa6";
import { GrShieldSecurity } from "react-icons/gr";
import { ImEarth } from "react-icons/im";
import Footer from "../layout/Footer";
import { Link } from "react-router-dom";
import IndigisBrouchure from "../assests/PDF/INDIGIS Enterprise.pdf";

const Indigis = () => {
  return (
    <>
      <Navbar />
      <div
        className="relative bg-cover bg-black bg-opacity-60 bg-center min-h-screen"
        style={{ backgroundImage: `url(${image1})` }}
      >
        <div className="relative z-10 min-h-screen flex flex-col justify-center items-center px-6 md:px-12 text-center">
          <h1 className="text-white text-2xl md:text-4xl xl:text-5xl font-bold max-w-4xl leading-tight">
            India’s Sovereign Geospatial Intelligence Platform
          </h1>

          <p className="text-gray-200 mt-4 text-sm md:text-base max-w-3xl">
            The Authorized Technology Transfer Partner for CAIR, DRDO’s INDIGIS
            Enterprise. Empowering Defence and Critical Infrastructure with data
            sovereignty and zero vendor lock-in.
          </p>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-6 mt-8">
            <Link to="/contact-us">
              <button
                className="bg-primary text-white font-bold px-8 py-3 rounded-full
                   hover:bg-white hover:text-primary transition-all duration-300"
              >
                Request Demo
              </button>
            </Link>

            <a
              href={IndigisBrouchure}
              download
              className="bg-white text-primary font-bold px-8 py-3 rounded-full
                   border-2 border-primary hover:bg-primary hover:text-white
                   transition-all duration-300"
            >
              Brochure
            </a>
            <button
           
                className="bg-primary text-white font-bold px-8 py-3 rounded-full
                   hover:bg-white hover:text-primary transition-all duration-300"
              >
                 <a href={'https://indigistechk.com/'} target="_blank">IndiGIS
           </a>
                
              </button>
          </div>
        </div>
      </div>

      <section className="bg-gray-100">
        <div className="px-2 py-5 md:px-4 md:py-16 flex flex-col gap-7">
          <h1 className="font-bold text-center md:text-5xl  mx-auto max-w-[55rem]  text-2xl '">
            Secured. Indigenous. Atmanirbhar.
          </h1>
          <p className="text-center mx-auto max-w-3xl">
            In an era of geopolitical uncertainty, reliance on foreign
            geospatial kernels poses a strategic risk. INDIGIS Enterprise is
            India’s answer to data sovereignty. Built on technology transferred
            from the Centre for Artificial Intelligence and Robotics (CAIR),
            DRDO, INDIGIS ensures that your critical operational data remains
            under Indian control.
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-8 md:px-16 px-3">
            <div className="group flex flex-col bg-white p-6 rounded-xl shadow-md max-w-sm text-center items-center">
              <CiLock className="text-3xl mb-4   group-hover:text-primary transition-colors duration-300" />
              <h3 className="tracking-tight text-primary text-lg font-bold  group-hover:text-blue-600">
                Zero Vendor Lock-in
              </h3>
              <p className="mt-2 text-gray-600">
                Complete autonomy from foreign policy restrictions or license
                withdrawals.
              </p>
            </div>

            <div className="group flex flex-col bg-white p-6 rounded-xl shadow-md max-w-sm text-center items-center">
              <MdOutlineSecurity className="text-3xl mb-4 group-hover:text-primary" />
              <h3 className="tracking-tight text-primary text-lg font-bold  group-hover:text-blue-600">
                DRDO Certified Security:
              </h3>
              <p className="mt-2 text-gray-600">
                High standards of governance, cyber security, and privacy
                protocols built for the Indian Armed Forces.
              </p>
            </div>

            <div className="group flex flex-col bg-white p-6 rounded-xl shadow-md max-w-sm text-center items-center">
              <GrLicense className="text-3xl mb-4 group-hover:text-primary" />
              <h3 className="tracking-tight text-primary text-lg font-bold  group-hover:text-blue-600">
                Perpetual Licensing:
              </h3>
              <p className="mt-2 text-gray-600">
                A cost-effective ownership model compared to recurring foreign
                subscriptions.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white">
        <div className="px-4 py-12 md:px-12 md:py-20 flex flex-col gap-12">
          <div className="flex flex-col gap-4">
            <h1 className="font-bold text-center text-2xl md:text-5xl mx-auto max-w-[55rem]">
              Multi-Domain Situational Awareness
            </h1>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 md:gap-12 md:px-16">
            {[
              {
                title: "Integrated Military Command & Control (C2)",
                points: [
                  [
                    "Common Operational Picture (COP)",
                    "Real-time visualization of assets, forces, and intelligence across 2D and 3D environments.",
                  ],
                  [
                    "Mission Planning",
                    "Advanced terrain analysis, line-of-sight computation, and optimized routing using MIL-STD-2525D symbology.",
                  ],
                  [
                    "Sensor Fusion",
                    "Integration of UAV, ground sensor, and satellite feeds into a single operational view.",
                  ],
                ],
                icon: <FaPersonMilitaryRifle />,
              },
              {
                title: "Aviation & Maritime Domain Awareness",
                points: [
                  [
                    "Naval Charting",
                    "specialized support for Electronic Navigational Charts (ENC) and bathymetric data analysis.",
                  ],
                  [
                    "Dynamic Tracking",
                    "Real-time intercept analysis for air and naval assets.",
                  ],
                ],
                icon: <FaPlane />,
              },
              {
                title: "Border & Perimeter Surveillance",
                points: [
                  [
                    "Intelligent Monitoring",
                    "Layering fence lines, terrain data, and surveillance coverage zones.",
                  ],
                  [
                    "Automated Alerts",
                    "Spatial-temporal rules trigger instant alerts for unauthorized boundary crossings.",
                  ],
                ],
                icon: <GrShieldSecurity />,
              },
              {
                title: "Civil & Disaster Resilience",
                points: [
                  [
                    "Disaster Response Platform",
                    "Real-time mapping of affected areas and logistics planning for NDMA and SDMAs.",
                  ],
                  [
                    "Geo-Cadastre",
                    "High-precision land parcel mapping supporting the Digital India Land Records Modernization Programme.",
                  ],
                ],
                icon: <ImEarth />,
              },
            ].map((card, idx) => (
              <div
                key={idx}
                className="group bg-gray-50 p-6 rounded-xl border border-transparent shadow-sm
                     hover:shadow-lg hover:border-primary/30 transition-all duration-300 flex flex-col gap-5"
              >
                <div className="bg-primary/10 p-3 rounded-md  w-fit">
                  {card.icon}
                </div>

                <h3 className="text-xl md:text-2xl font-semibold">
                  {card.title}
                </h3>

                <ul className="flex flex-col gap-3 text-gray-700 text-sm leading-relaxed">
                  {card.points.map(([label, text], i) => (
                    <li key={i}>
                      <span className="font-semibold">{label}:</span> {text}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="relative bg-gray-100 text-gray-900">
        <div className="px-6 py-16 md:px-16 md:py-24 flex flex-col gap-16">
          <div className="max-w-5xl mx-auto text-center flex flex-col gap-5">
            <h2 className="text-3xl md:text-6xl font-bold">
              Built for Enterprise Scale
            </h2>

            <p className="text-gray-600 text-sm md:text-base max-w-4xl mx-auto">
              INDIGIS is not just a tool; it is a comprehensive development
              environment designed for scale.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 max-w-7xl mx-auto">
            <div className="flex flex-col gap-8">
              {[
                {
                  title: "Robust SDK",
                  desc: (
                    <>
                      Over <span className="font-semibold">500+ APIs</span>{" "}
                      available for developers to build vertical-specific
                      applications.
                    </>
                  ),
                },
                {
                  title: "Enterprise Scale",
                  desc: (
                    <>
                      Capable of handling{" "}
                      <span className="font-semibold">
                        hundreds of terabytes of raster and vector data
                      </span>{" "}
                      across geographically dispersed networks.
                    </>
                  ),
                },
                {
                  title: "Cross-Platform Deployment",
                  desc: (
                    <>
                      Available as a{" "}
                      <span className="font-semibold">rich desktop client</span>
                      , <span className="font-semibold">thin web client</span>,
                      and{" "}
                      <span className="font-semibold">mobile application</span>{" "}
                      for field deployments.
                    </>
                  ),
                },
                {
                  title: "OGC Compliant",
                  desc: (
                    <>
                      Ensures interoperability with existing legacy systems and
                      adherence to global geospatial standards.
                    </>
                  ),
                },
              ].map((item, idx) => (
                <div key={idx} className="flex gap-5 items-start">
                  <div className="bg-primary p-1 mt-5 flex rounded-full justify-center shrink-0" />
                  <div>
                    <h3 className="text-xl md:text-2xl font-semibold">
                      {item.title}
                    </h3>
                    <p className="text-gray-600 text-sm md:text-base">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="relative bg-white rounded-2xl p-10 border border-gray-200 shadow-sm">
              <div className="flex flex-col gap-6">
                <h4 className="text-lg font-semibold text-primary">
                  Enterprise Architecture Footprint
                </h4>

                <div className="grid grid-cols-2 gap-6 text-sm text-gray-700">
                  <div className="border border-gray-200 rounded-lg p-4 text-center">
                    Desktop Client
                  </div>
                  <div className="border border-gray-200 rounded-lg p-4 text-center">
                    Web Client
                  </div>
                  <div className="border border-gray-200 rounded-lg p-4 text-center">
                    Mobile Deployment
                  </div>
                  <div className="border border-gray-200 rounded-lg p-4 text-center">
                    SDK / APIs
                  </div>
                </div>

                <div className="mt-6 border-t border-gray-200 pt-6 text-center text-sm text-gray-500">
                  Engineered for sovereign deployments, air-gapped networks, and
                  long-term platform evolution.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="relative bg-white text-gray-900">
        <div className="px-6 py-20 md:px-16 flex flex-col gap-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-7xl mx-auto">
            <div className="md:col-span-1 flex flex-col gap-6">
              <div className="flex ">
                <h2 className="text-3xl md:text-5xl font-bold leading-tight">
                  Commercial &<br />
                  Industrial Intelligence
                </h2>
              </div>

              <p className="text-gray-600 text-sm md:text-base">
                While born in Defence, INDIGIS delivers industrial-grade
                precision for large-scale commercial and public sector
                deployments.
              </p>
            </div>

            <div className="md:col-span-2 flex flex-col gap-8">
              <div
                className="relative bg-gray-100 rounded-2xl p-8 border border-gray-200
                        hover:bg-white hover:shadow-lg transition-all duration-300"
              >
                <h3 className="text-xl md:text-2xl font-semibold mb-3">
                  Mining & Resources
                </h3>
                <p className="text-gray-700 text-sm leading-relaxed">
                  Mine safety monitoring, volume calculation, and environmental
                  impact assessment for public sector enterprises such as
                  <span className="font-semibold"> Coal India</span> and
                  <span className="font-semibold"> NMDC</span>.
                </p>
              </div>

              <div
                className="relative bg-gray-100 rounded-2xl p-8 border border-gray-200
                        hover:bg-white hover:shadow-lg transition-all duration-300"
              >
                <h3 className="text-xl md:text-2xl font-semibold mb-3">
                  Critical Infrastructure
                </h3>
                <p className="text-gray-700 text-sm leading-relaxed">
                  Network mapping and spatial intelligence for
                  <span className="font-semibold">
                    {" "}
                    power transmission systems
                  </span>
                  ,<span className="font-semibold"> oil & gas pipelines</span>,
                  and
                  <span className="font-semibold">
                    {" "}
                    telecommunication rights-of-way
                  </span>
                  .
                </p>
              </div>

              {/* Panel 3 */}
              <div
                className="relative bg-gray-100 rounded-2xl p-8 border border-gray-200
                        hover:bg-white hover:shadow-lg transition-all duration-300"
              >
                <h3 className="text-xl md:text-2xl font-semibold mb-3">
                  Smart Cities
                </h3>
                <p className="text-gray-700 text-sm leading-relaxed">
                  Utility mapping, property taxation, and traffic management for
                  Urban Local Bodies and municipal administrations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="relative bg-gray-100 text-gray-900">
        <div className="px-6 py-20 md:px-16 flex flex-col gap-16 max-w-7xl mx-auto">
          <div className="flex flex-col gap-5 max-w-4xl">
            <h2 className="text-3xl md:text-5xl font-bold">
              A Partnership for Progress
            </h2>

            <p className="text-gray-600 text-sm md:text-base">
              We offer flexible engagement models tailored to the evolving needs
              of Government and Enterprise stakeholders, ensuring confidence at
              every stage of adoption.
            </p>
          </div>

          <div className="relative flex flex-col gap-12 md:gap-16">
            <div className="absolute left-4 top-0 h-full w-px bg-primary/30 hidden md:block" />

            <div className="relative md:pl-16 flex flex-col gap-4">
              <div className="flex items-center gap-4">
                <div className="bg-primary text-white w-10 h-10 rounded-full flex items-center justify-center font-semibold">
                  1
                </div>
                <h3 className="text-xl md:text-2xl font-semibold">
                  Turnkey Projects
                </h3>
              </div>

              <p className="text-gray-700 text-sm md:text-base max-w-3xl">
                End-to-end implementation covering requirements analysis, pilot
                execution, system integration, and full-scale operational
                rollout.
              </p>
            </div>

            <div className="relative md:pl-16 flex flex-col gap-4">
              <div className="flex items-center gap-4">
                <div className="bg-primary text-white w-10 h-10 rounded-full flex items-center justify-center font-semibold">
                  2
                </div>
                <h3 className="text-xl md:text-2xl font-semibold">
                  Pilot-First Approach
                </h3>
              </div>

              <p className="text-gray-700 text-sm md:text-base max-w-3xl">
                Validate INDIGIS capabilities through controlled pilots within a
                specific sector, region, or district before committing to
                organization-wide deployment.
              </p>
            </div>

            <div className="relative md:pl-16 flex flex-col gap-4">
              <div className="flex items-center gap-4">
                <div className="bg-primary text-white w-10 h-10 rounded-full flex items-center justify-center font-semibold">
                  3
                </div>
                <h3 className="text-xl md:text-2xl font-semibold">
                  Custom Development
                </h3>
              </div>

              <p className="text-gray-700 text-sm md:text-base max-w-3xl">
                Leverage our in-house engineering team to design and build
                customer-specific modules, workflows, and integrations using the
                INDIGIS SDK.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="relative bg-slate-800 text-white">
        <div className="px-6 py-20 md:px-16 flex flex-col items-center text-center gap-8 max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-bold leading-tight">
            Secure Your Operational Future Today
          </h2>

          <p className="text-gray-300 text-sm md:text-lg max-w-3xl">
            Move to a platform that guarantees data sovereignty, security, and
            scale.
          </p>

          <div className="w-24 h-1 bg-primary rounded-full" />

          <Link to="/contact-us">
            <button
              className="mt-4 px-8 py-4 bg-primary text-white font-semibold text-base md:text-lg
                 rounded-lg shadow-lg hover:bg-primary/90 hover:shadow-xl
                 transition-all duration-300"
            >
              Schedule a Demo with our GIS Experts
            </button>
          </Link>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Indigis;
